import React from 'react';
import CircleInitials from '../CircleInitials/CircleInitials';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout-icon.svg';
import { ReactComponent as UnfoldIcon } from '../../assets/icons/unfold-icon.svg';
import './Profile.css';
import { useNavigate } from 'react-router-dom';

const PLAN_LABELS = {
    free: 'Free',
    early_1_5: '1-5 Clients',
    early_6_10: '6-10 Clients',
    early_11_20: '11-20 Clients',
    early_21_50: '21-50 Clients',
    early_51_100: '51-100 Clients',
};

const Profile = ({ user, workspace, org, setShowPopup, handleLogout, handleSwitchOrg, pendingInviteCount = 0 }) => {
    const navigate = useNavigate();

    const showSwitchOrg = (user.orgIds?.length > 1) || pendingInviteCount > 0;

    const planLabel = PLAN_LABELS[org?.subscription?.plan] || 'Free';

    function renameRole(role) {
        if (role === 'admin') return 'Admin';
        if (role === 'member') return 'Member';
        return 'N/A';
    }

    const handleManageSubscription = () => {
        setShowPopup(false);
        navigate('/settings', { state: { selectedMenuItem: 'subscription' } });
    }

    return (
        <div className='user-profile'>
            <div className='user-details-container'>
                <CircleInitials text={user.name} classN='profile-initials' />
                <div className='user-details'>
                    <h3 className='user-name'>{user.name}</h3>
                    <h3 className='user-email'>{user.email}</h3>
                </div>
            </div>
            <hr />
            <div className='workspace-details-container'>
                <div className='workspace-details'>
                    <h3 className='workspace-leader'>Organization Name</h3>
                    <h3 className='workspace-text'>{org.name}</h3>
                </div>
                <div className='workspace-details'>
                    <h3 className='workspace-leader'>Role</h3>
                    <h3 className='workspace-text'>{renameRole(user.orgRole)}</h3>
                </div>
                <div className='workspace-details'>
                    <h3 className='workspace-leader'>Subscription</h3>
                    <h3 className='workspace-text'>{planLabel}</h3>
                    <div className='upgrade' onClick={handleManageSubscription}>Manage</div>
                </div>
            </div> 
            <hr />
            <div className='logout-button-container'>
                <div className='logout-button' onClick={handleLogout}>
                    <LogoutIcon className='logout-icon'/>
                    <h3>Sign Out</h3>
                </div>
                {showSwitchOrg && (
                    <div className='logout-button' onClick={handleSwitchOrg}>
                        <UnfoldIcon className='logout-icon'/>
                        <h3>Switch Org</h3>
                        {pendingInviteCount > 0 && (
                            <span className='invite-badge'>{pendingInviteCount}</span>
                        )}
                    </div>
                )}
               
            </div>
        </div>
    );
};

export default Profile;
